module.exports = {
  VERSION: "1.38.0", // Wersja aplikacji frontendowej
  MIN_API_VERSION: "24.07.0", // Powinno być zgodnę z wersją  API
}
